// Psychologist/PsychologistHead.tsx
import React from 'react';
import Head from 'Core/components/Head';
import {IPsychologist} from '../../Types/psychology/psychologist';
import {DOMAIN_URL} from 'Auth/axiosConfig';

interface PsychologistHeadProps {
    psychologist: IPsychologist;
}

const PsychologistHead: React.FC<PsychologistHeadProps> = ({psychologist}) => {
    return (
        <Head
            title={`Психолог онлайн ${psychologist.user.first_name} ${psychologist.user.last_name} | Помощь психолога | Лайф Хелп`}
            description={`${psychologist.user.first_name} ${psychologist.user.last_name} - психолог сервиса Лайф Хелп. Записаться на онлайн консультацию с психологом ${psychologist.user.first_name} ${psychologist.user.last_name}.`}
            keywords={`онлайн психолог ${psychologist.user.first_name} ${psychologist.user.last_name}, помощь психолога ${psychologist.user.first_name} ${psychologist.user.last_name}, ${psychologist.user.first_name} ${psychologist.user.last_name}, онлайн консультации ${psychologist.user.first_name} ${psychologist.user.last_name}`}
            author="Life-Help"
            robots="index, follow"
            ogImage={`${DOMAIN_URL}${psychologist.user.avatar}`}
            ogUrl={`${DOMAIN_URL}/psychologists/${psychologist.id}`}
            twitterImage={`${DOMAIN_URL}${psychologist.user.avatar}`}
            twitterUrl={`${DOMAIN_URL}/psychologists/${psychologist.id}`}
            appleTouchIcon={`${DOMAIN_URL}/static/img/icons/apple-touch-icon.png`}
            canonicalUrl={`${DOMAIN_URL}/psychologists/${psychologist.id}`}
        />
    );
};

export default PsychologistHead;